import React from 'react';
import { Helmet } from 'react-helmet';

const RecipesJsonLd = ({ recipesListElements = [] }) => {
  const jslonld = `{
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      ${recipesListElements.map(
    (recipeListElements) => `{
        "@type": "ListItem",
        "position": ${recipeListElements.position},
        "image": "${recipeListElements.imageUrl}",
        "url": "${recipeListElements.url}",
        "name": "${recipeListElements.recipeTitle}"
      }`,
  )}
     ]
  }`;

  return (
    <Helmet>
      <script
        type="application/ld+json"
      >
        {jslonld}
      </script>
    </Helmet>
  );
};

export default RecipesJsonLd;
